import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import Link for the signup link

import phone from "../Assets/ScreenShot.png";
import android from "../Assets/android.svg";
import session from "../Utils/session";

export default function LandingPage({ isMobile }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (session.isAuthenticated()) {
      navigate("/app");
    }
  }, [navigate]);

  return (
    <div className="min-h-screen w-full flex flex-col bg-gradient-to-b from-neutral-950 via-neutral-900 to-neutral-950 text-text relative overflow-hidden">
      {/* Ambient blue glow */}
      <div className="pointer-events-none absolute top-1/4 right-0 w-[500px] h-[500px] bg-blue-500/10 blur-[120px] rounded-full" aria-hidden />
      <div className="pointer-events-none absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-500/5 blur-[100px] rounded-full" aria-hidden />

      <main className="flex-grow w-full relative z-10">
        {/* Hero Section */}
        <div className="relative w-full px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-center lg:justify-between gap-12">
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left w-full lg:w-1/2">
            <div className="text-[10px] uppercase tracking-[0.4em] text-text-muted mb-4 animate-fade-in">
              Muzio · v1
            </div>
            <h1 className="text-5xl md:text-7xl font-extrabold leading-[1.05] mb-6 animate-fade-in">
              Your music.<br/>Your vibe.
            </h1>
            <p className="text-lg md:text-xl text-text-muted mb-10 animate-slide-up max-w-lg">
              Host, share, and discover tracks with a community of creators. Built for listening sessions and live mixing.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 animate-slide-up animation-delay-400">
              {!isMobile && (
                <a className="px-6 h-12 inline-flex items-center justify-center bg-gradient-to-b from-blue-500 to-blue-700 border border-blue-400 text-white rounded-md text-xs font-bold uppercase tracking-wider shadow-md hover:from-blue-400 hover:to-blue-600 active:translate-y-[1px] transition-all" href="/app">
                  Open Web App
                </a>
              )}

              <a
                className="px-6 h-12 inline-flex items-center justify-center bg-gradient-to-b from-neutral-700 to-neutral-900 border border-neutral-600 text-neutral-200 rounded-md text-xs font-bold uppercase tracking-wider shadow-md hover:from-neutral-600 hover:to-neutral-800 active:translate-y-[1px] transition-all"
                href="https://muzio.ioprodz.com/api/app/update"
              >
                <img src={android} className="w-4 h-4 mr-2" alt="Android icon" />
                Download for Android
              </a>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-12 max-w-lg w-full animate-slide-up animation-delay-200">
              <div className="border-l-2 border-blue-500/40 pl-3 py-1">
                <div className="text-[9px] uppercase tracking-[0.18em] text-text-muted font-semibold mb-1">Stream</div>
                <div className="text-xs text-text-muted">Upload tracks effortlessly</div>
              </div>
              <div className="border-l-2 border-pink-500/40 pl-3 py-1">
                <div className="text-[9px] uppercase tracking-[0.18em] text-text-muted font-semibold mb-1">Mix</div>
                <div className="text-xs text-text-muted">Two-deck DJ mode built-in</div>
              </div>
              <div className="border-l-2 border-emerald-500/40 pl-3 py-1">
                <div className="text-[9px] uppercase tracking-[0.18em] text-text-muted font-semibold mb-1">Share</div>
                <div className="text-xs text-text-muted">Playlists for friends</div>
              </div>
            </div>
          </div>

            <div className="relative w-full lg:w-1/2 flex justify-center items-center">
              <div className="absolute inset-0 bg-blue-500/10 blur-3xl rounded-full" aria-hidden></div>
              <img
                src={phone}
                alt="application screenshot"
                className="w-full max-w-sm lg:max-w-md h-auto rounded-xl shadow-2xl border border-neutral-800 transform rotate-3 hover:rotate-0 transition-transform duration-500 z-10 relative"
              />
            </div>
          </div>
        </div>

      </main>

      {/* Footer */}
      <footer className="w-full text-center py-8 text-text-muted mt-auto relative z-10 border-t border-neutral-800">
        <div className="flex flex-wrap justify-center gap-6 mb-3 text-xs uppercase tracking-wider">
          <Link
            to="/auth"
            className="text-text-muted hover:text-text font-semibold transition-colors"
          >
            Login
          </Link>
          <Link
            to="/join"
            className="text-text-muted hover:text-text font-semibold transition-colors"
          >
            Sign Up
          </Link>
          <a
            href="/app"
            className="text-text-muted hover:text-text font-semibold transition-colors"
          >
            Web App
          </a>
        </div>
        <p className="text-[11px] opacity-60">
          © {new Date().getFullYear()} Muzio. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
